import { LE_CONTRACTED_HOTEL_TYPES } from 'constants/offer'
import { MAX_CAROUSEL_ITEM_COUNT } from './common/constants'

/** Initial rollout markets for the local destination offer carousel below trending destinations */
export const LOCAL_DESTINATION_OFFER_CAROUSEL_REGIONS = new Set(['FR', 'DE'])

/**
 * Stop waiting for unresolved eligibility checks and show or hide based on resolved destinations.
 *
 * We intentionally do not freeze an empty result when this elapses: in-flight light-search
 * responses may still add eligible destinations afterward (slow networks). That avoids
 * permanently hiding the module, but the carousel can appear after the skeleton is gone,
 * which may cause layout shift — an accepted trade-off for this AC.
 */
export const LOCAL_DESTINATION_OFFER_ELIGIBILITY_TIMEOUT_MS = 10_000

export const LOCAL_DESTINATION_OFFER_CAROUSEL_FILTERS: App.OfferListFilters = {
  offerTypes: LE_CONTRACTED_HOTEL_TYPES,
  frontPageVisibleOnly: true,
  limit: MAX_CAROUSEL_ITEM_COUNT,
}

export function buildLocalDestinationOfferListFilters(destinationId: string): App.OfferListFilters {
  return {
    ...LOCAL_DESTINATION_OFFER_CAROUSEL_FILTERS,
    destinationId,
  }
}
